// Runtime configuration, fetched from `/config.json` at boot.
//
// The bundle is environment-agnostic: the same S3 objects serve dev and prod,
// and the deploy writes `config.json` beside them. Nothing here is a secret —
// a public client id, a tenant id and an API base URL.

export interface RuntimeConfig {
  api_base_url: string
  entra: {
    tenant_id: string
    client_id: string
    /** Scope for the API's access token, e.g. `api://<id>/access_as_user`. */
    api_scope: string
    /** Delegated Graph scope for the staff picker. */
    graph_scopes?: string[]
  }
  environment?: string
  version?: string
}

let cached: RuntimeConfig | null = null

export async function loadConfig(): Promise<RuntimeConfig> {
  if (cached) return cached
  const res = await fetch('/config.json', { cache: 'no-store' })
  if (!res.ok) throw new Error(`Could not load /config.json (HTTP ${res.status})`)
  cached = (await res.json()) as RuntimeConfig
  return cached
}

/** Set directly by the local harness, which has no deploy to write the file. */
export function setConfig(config: RuntimeConfig): void {
  cached = config
}

export function currentConfig(): RuntimeConfig {
  if (!cached) throw new Error('Runtime configuration has not been loaded yet.')
  return cached
}
